import { PROVIDER_MAIN_USER_TYPE } from './providerRequirementsCheck';

/**
 * Whether a listing's author should appear on main search (/s).
 * Provider-main authors must have providerRequirementsComplete === true.
 */
export const isListingAuthorEligibleForSearch = (listing, includedUsersById = new Map()) => {
  const authorRef = listing?.relationships?.author?.data;
  if (!authorRef?.id) {
    return true;
  }

  const authorId = typeof authorRef.id === 'string' ? authorRef.id : authorRef.id.uuid;
  const author = includedUsersById.get(authorId);
  if (!author) {
    return false;
  }

  const userType = author?.attributes?.profile?.publicData?.userType;
  if (userType !== PROVIDER_MAIN_USER_TYPE) {
    return true;
  }

  return author?.attributes?.profile?.publicData?.providerRequirementsComplete === true;
};

export const buildIncludedUsersById = included => {
  const map = new Map();
  (included || []).forEach(item => {
    if (item?.type === 'user' && item?.id) {
      const id = typeof item.id === 'string' ? item.id : item.id.uuid;
      map.set(id, item);
    }
  });
  return map;
};

export const filterListingsByProviderRequirements = (listings, included) => {
  const includedUsersById = buildIncludedUsersById(included);
  return (listings || []).filter(listing =>
    isListingAuthorEligibleForSearch(listing, includedUsersById)
  );
};
